<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Cash Collection List</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between py-3"
            >
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'firstname' ||
                          item.field.id == 'lastname' ||
                          item.field.id == 'email' ||
                          item.field.id == 'middlename' ||
                          item.field.id == 'mref')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'remitterstatus'"
                    >
                      <span class="float-label w-100">
                        <label>Select Remiter Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="remiterOption"
                          label="name"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>

                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'payout_source'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label w-100">
                          <label>Select Payout type</label>
                          <multiselect
                            placeholder=""
                            v-model="item.payout.type"
                            :show-labels="false"
                            :options="filterpayouttype"
                            label="name"
                            track-by="value"
                            :searchable="true"
                            @select="selectPayout"
                          ></multiselect>
                        </span>
                      </div>
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                        v-if="item.payout.type"
                      >
                        <span class="float-label w-100">
                          <label>Select Payout Source</label>
                          <multiselect
                            placeholder=""
                            v-model="item.payout.source"
                            :show-labels="false"
                            :options="payoutSourceOption"
                            label="name"
                            track-by="value"
                            :searchable="true"
                            @search-change="searchPayoutSource"
                          ></multiselect>
                        </span>
                      </div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'country'"
                    >
                      <span class="float-label w-100">
                        <label>Select Dest. Country</label>
                        <v-select
                          v-model="item.country"
                          :options="countryList"
                          multiple
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'sourcecountry'"
                    >
                      <span class="float-label w-100">
                        <label>Select Source Country</label>
                        <v-select
                          v-model="item.country"
                          :options="countryList"
                          multiple
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'transactionstatus'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">
                          Select Transaction Status
                        </label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="transactionStatus"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'transactiontype'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Select Transaction Type</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="transactiontypeOptions"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'cko_capture'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">CKO Capture Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="[
                            { value: 'captured', name: 'Captured' },
                            { value: 'not_captured', name: 'To be Captured' },
                          ]"
                          label="name"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'amount'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label">
                          <label for="transaction">Select</label>
                          <multiselect
                            placeholder=""
                            v-model="item.amount.type"
                            :show-labels="false"
                            :options="amountOptions"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            @select="amountFieldUpdate"
                          ></multiselect>
                        </span>
                        <div class="line"></div>
                      </div>
                      <div class="form-group m-0 column-2-half">
                        <input
                          class="form-control"
                          type="text"
                          v-model="item.amount.value"
                          :placeholder="'Enter ' + item.field.name"
                          @keypress="onlyNumber($event)"
                        />
                        <div class="line"></div>
                      </div>
                    </div>
                    <div
                      class="column-2"
                      v-if="
                        item.field && item.field.id == 'transaction_history'
                      "
                    >
                      <div class="form-group m-0 column-2-half">
                        <span class="float-label">
                          <input
                            class="form-control"
                            type="text"
                            id="sender"
                            v-model="item.history.sender"
                            placeholder="Enter sender PA ref"
                          />
                          <label for="sender" class="control-label">
                            Enter sender PA ID
                          </label>
                          <div class="line"></div>
                        </span>
                      </div>
                      <div class="form-group m-0 column-2-half">
                        <span class="float-label">
                          <input
                            class="form-control"
                            type="text"
                            id="receiver"
                            v-model="item.history.receiver"
                            placeholder="Enter receiver PA ref"
                          />
                          <label for="receiver" class="control-label">
                            Enter receiver Account / Mobile no
                          </label>
                          <div class="line"></div>
                        </span>
                      </div>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'date'"
                    >
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel & Close
                  </button>
                </div>
              </b-collapse>
            </div>
            <!-- displayed FIlters -->
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for country filter-->
                <template
                  v-if="
                    item.filter_field == 'country' ||
                    item.filter_field == 'sourcecountry'
                  "
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="country in item.filter_value"
                    :key="country"
                  >
                    {{
                      countryList.filter(
                        (data) => data.countryid === country,
                      )[0]?.countryname
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeCountry(country, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Only for Date -->
                <template v-else-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Only for Date -->
                <template v-else-if="item.filter_field == 'payout_source'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removePayoutSource(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Only for transaction_history -->
                <template
                  v-else-if="item.filter_field == 'transaction_history'"
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(item, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="item">
                      {{ indexValue + ": " + item }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removetransaction_history(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Other filter -->
                <span class="badge badge-warning-solid" v-else>
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #cell(srccountry)="data">
                <div class="d-flex align-items-center">
                  <span :class="data.value.flagClass"></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.srccountry?.name"
                  >
                    {{ data.item.srccountry?.isocode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(datetime)="data">
                <strong>{{ data.value.date }}</strong>
                <small class="text-grey d-block">
                  {{ data.value.time }}
                </small>
              </template>
              <!-- <template #cell(sourceamount)="data">
                                <span class="d-block" v-b-tooltip.hover :title="data.item.destcountry?.name">{{ data.value }}</span>
                            </template> -->
              <template #cell(custRefno)="data">
                <div class="align-items-center d-block">
                  <div>
                    <i
                      class="fa fa-apple font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 1"
                    ></i>
                    <i
                      class="fa fa-android text-success font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 2"
                    ></i>
                    <i
                      class="fa fa-user font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 3"
                    ></i>
                    <i
                      class="fa fa-globe text-info font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 4"
                    ></i>
                    <router-link
                      class="font-color"
                      to="/transaction/details"
                      target="_blank"
                    >
                      {{ data.value }}
                    </router-link>
                    <i
                      class="fa fa-copy"
                      v-if="data.value != '-'"
                      @click="copyText(data.value, 'PA Ref')"
                    ></i>
                  </div>
                  <span class="text-grey d-block">
                    5b3e6e75-3..
                    <i
                      class="fa fa-copy"
                      v-if="data.value != '-'"
                      @click="
                        copyText('5b3e6e75-364c-4bd9-b36c-d74188afc750', 'Ref')
                      "
                    ></i>
                  </span>
                </div>
              </template>
              <template #cell(destamount)="data">
                <span
                  class="d-block"
                  v-b-tooltip.hover
                  :title="data.item.destcountry?.name"
                >
                  {{ data.value }}
                </span>
              </template>
              <template #cell(status)="data">
                <p class="function-badge badge-group-table mb-0 text-center">
                  <span class="badge ml-0 d-block" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(sms_status)="data">
                <p class="function-badge badge-group-table mb-0 text-center">
                  <span class="badge ml-0 d-block" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Get MTMS Status</b-dropdown-item>
                  <b-dropdown-item>Cancel</b-dropdown-item>
                  <b-dropdown-item>Hold</b-dropdown-item>
                  <b-dropdown-item>Payment Capture</b-dropdown-item>
                  <b-dropdown-item @click="sendNotification(data.item)">
                    Send Notification
                  </b-dropdown-item>
                  <b-dropdown-item @click="trans_status_update(data.item)">
                    Transaction Status Update
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="trans_payout_status_update(data.item)"
                  >
                    Payout Status Update
                  </b-dropdown-item>
                  <b-dropdown-item @click="refund(data.item)">
                    Refund
                  </b-dropdown-item>
                  <b-dropdown-item>Hide</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Notification -->
            <b-modal
              id="transactionNotification"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Send Notification
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(transactionNotificationSubmit)">
                    <ValidationProvider
                      name="notification_type"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.type &&
                            notification.type.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_type">
                            Notification Type*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.type"
                            :show-labels="false"
                            :options="notificationTypeOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.type &&
                              notification.type.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_action"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.action &&
                            notification.action.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_action">
                            Notification Action*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.action"
                            :show-labels="false"
                            :options="notificationActionOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.action &&
                              notification.action.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_custom"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="notification.action == 'Other'"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:
                            (errors.length && !notification.custom) ||
                            errors[0],
                          success: notification.custom && !errors[0],
                        }"
                      >
                        <span class="float-label mb-1">
                          <textarea
                            class="form-control"
                            id="notification_custom"
                            v-model="notification.custom"
                            placeholder=" "
                          ></textarea>
                          <label
                            for="notification_custom"
                            class="control-label"
                          >
                            Custom Notification Text*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              (errors.length && !notification.custom) ||
                              errors[0]
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="notification.custom && !errors[0]"
                          ></i>
                        </span>
                        <span class="text-danger">
                          <b>Note :-</b>
                          List of Placeholders: [trans_ref_#], [cust_name],
                          [trans_receiver]
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transactionNotification')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- transaction Status -->
            <b-modal
              id="transactionStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Transaction Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="passes(statusUpdateSubmit('transaction'))"
                  >
                    <ValidationProvider
                      name="transaction_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            transactionStatusUpdate.status &&
                            transactionStatusUpdate.status.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="transaction_status">
                            Transaction Status*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="transactionStatusUpdate.status"
                            :show-labels="false"
                            :options="UpdateStatusoption"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              transactionStatusUpdate.status &&
                              transactionStatusUpdate.status.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label mb-1">
                        <textarea
                          class="form-control"
                          id="transaction_cashflow"
                          v-model="transactionStatusUpdate.paymentref"
                          placeholder=" "
                        ></textarea>
                        <label for="transaction_cashflow" class="control-label">
                          Payment Reference
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transactionStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- payout Status -->
            <b-modal
              id="payoutStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Payout Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="
                      passes(statusUpdateSubmit('transaction_ref'))
                    "
                  >
                    <ValidationProvider
                      name="transactionpayout_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            payoutStatusUpdate.status &&
                            payoutStatusUpdate.status.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="transactionpayout_status">
                            Payout Status*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="payoutStatusUpdate.status"
                            :show-labels="false"
                            :options="transactionPayoutStatusoption"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              payoutStatusUpdate.status &&
                              payoutStatusUpdate.status.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label mb-1">
                        <textarea
                          class="form-control"
                          id="transaction_paymentref"
                          v-model="payoutStatusUpdate.paymentref"
                          placeholder=" "
                        ></textarea>
                        <label
                          for="transaction_paymentref"
                          class="control-label"
                        >
                          Payment Reference
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('payoutStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <RefundRemitterCredit :remitterCredit="remitterCredit" />
            <!-- Table Pagination -->
            <div
              class="py-3 d-flex align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapState, mapGetters } from "vuex";
import "vue-select/dist/vue-select.css";
const { ValidationObserver, ValidationProvider } = require("vee-validate");
const moment = require("moment");
import RefundRemitterCredit from "../../core/RefundRemitterCredit.vue";
export default {
  name: "PartnerListComponent",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
    "v-select": () => import("vue-select"),
    "main-loader": LoaderComponent,
    ValidationObserver,
    ValidationProvider,
    RefundRemitterCredit,
  },
  data() {
    return {
      notification: {
        type: "",
        action: "",
        custom: "RE : [trans_ref_#]",
      },
      notificationTypeOptions: [
        "Push notification",
        "Dismiss popup",
        "Model popup",
        "SMS",
      ],
      notificationActionOptions: ["ID Notification", "Other"],
      UpdateStatusoption: [
        "Awaiting Funds",
        "Pending Processing",
        "Sent for Payment",
        "Beneficiary Paid",
        "Cancelled",
      ],
      transactionPayoutStatusoption: [
        "Pending",
        "Success",
        "Error",
        "Failed",
        "Direct-112",
        "Paid-TIGOMomo",
        "Paid-MDW-GHPS",
        "Paid-MDW-TP",
        "Paid-MFS",
        "Paid-MDW-PAYAZA",
        "Paid-MDW-RAFIKI",
        "Paid-PGL",
        "Paid-MTN-MOMO",
        "Paid NSANO",
      ],
      transactionStatusUpdate: {
        status: "Awaiting Funds",
        paymentref: "7944318b-522d-4520-ac16-b5dc32a8792c",
      },
      payoutStatusUpdate: {
        status: "Pending",
        paymentref: "7944318b-522d-4520-ac16-b5dc32a8792c",
      },
      remitterCredit: {
        customer: "",
        comment: "",
        amount: "",
        creditType: "",
        refundType: "",
      },
      fields: [
        { key: "srccountry", label: "S.C.", thClass: "th_sortfix text-left" },
        { key: "datetime", label: "Date", thClass: "th_sortfix" },
        { key: "sender", label: "Sender", thClass: "th_sortfix" },
        { key: "receiver", label: "Receiver", thClass: "th_sortfix" },
        { key: "custRefno", label: "Trans. Ref", thClass: "th_sortfix" },
        { key: "sourceamount", label: "Source Amount.", thClass: "th_sortfix" },
        {
          key: "destamount",
          label: "Dest Amount",
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        { key: "status", label: "Trans. Status", thClass: "th_sortfix" },
        { key: "sms_status", label: "SMS Status", thClass: "th_sortfix" },
        {
          key: "payout_partner",
          label: "Payout Partner",
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      items: [
        {
          srccountry: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          datetime: { date: "25-05-2023 ", time: "6:11 PM GMT" },
          sender: "Tony Stark",
          receiver: "Jones Amegbor",
          sourceamount: "GBP 3.93",
          custRefno: "PM1234",
          destcountry: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          destamount: "GHS 0.50",
          status: { name: "Failed", class: "badge-danger" },
          sms_status: { name: "Pending", class: "badge-danger" },
          payout_partner: "--",
          action: "Actions",
        },
        {
          srccountry: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          datetime: { date: "25-05-2023 ", time: "6:11 PM GMT" },
          sender: "JonesTest Amegbor",
          receiver: "Akosua Nunoo",
          sourceamount: "GBP 3.93",
          custRefno: "PM1234",
          destcountry: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          destamount: "GHS 0.50",
          status: { name: "Initial Request", class: "badge-warning" },
          sms_status: { name: "Pending", class: "badge-danger" },
          payout_partner: "--",
          action: "Actions",
        },
        {
          srccountry: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          datetime: { date: "25-05-2023 ", time: "6:11 PM GMT" },
          sender: "Antonio Bortoletto",
          receiver: "Jones Amegbor",
          sourceamount: "GBP 3.93",
          custRefno: "PM1234",
          destcountry: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          destamount: "GHS 0.50",
          status: { name: "Callback Success", class: "badge-success" },
          sms_status: { name: "Sent", class: "badge-success" },
          payout_partner: "Partner Bank",
          action: "Actions",
        },
        {
          srccountry: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          datetime: { date: "25-05-2023 ", time: "6:11 PM GMT" },
          sender: "Ben Murphy",
          receiver: "Jones Amegbor",
          sourceamount: "GBP 3.93",
          custRefno: "PM1234",
          destcountry: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          destamount: "GHS 0.50",
          status: { name: "Callback Failed", class: "badge-danger" },
          sms_status: { name: "Pending", class: "badge-danger" },
          payout_partner: "--",
          action: "Actions",
        },
        {
          srccountry: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          datetime: { date: "25-05-2023 ", time: "6:11 PM GMT" },
          sender: "Ben Murphy",
          receiver: "Jones Amegbor",
          sourceamount: "GBP 3.93",
          custRefno: "PM1234",
          destcountry: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          destamount: "GHS 0.50",
          status: { name: "Callback Failed", class: "badge-danger" },
          sms_status: { name: "Pending", class: "badge-danger" },
          payout_partner: "--",
          action: "Actions",
        },
      ],

      isVisibleFilter: false,
      displayFilters: [],
      filterField: [
        { id: "firstname", name: "First Name", $isDisabled: false },
        { id: "middlename", name: "Middle Name", $isDisabled: false },
        { id: "lastname", name: "Last Name", $isDisabled: false },
        // { id: 'email', name: 'Email' ,$isDisabled:false},
        // { id: 'country', name: 'Dest. Country' ,$isDisabled:false},
        // { id: 'sourcecountry', name: 'Source Country' ,$isDisabled:false},
        { id: "date", name: "Date", $isDisabled: false },
        // { id: 'remitterstatus', name: 'Remitter Status' ,$isDisabled:false},
        {
          id: "transactionstatus",
          name: "Transaction Status",
          $isDisabled: false,
        },
        // { id: 'transactiontype', name: 'Transaction Type' ,$isDisabled:false},
        // { id: 'transaction_history', name: 'Transaction History' ,$isDisabled:false},
        // { id: 'payout_source', name: 'Payout Source' ,$isDisabled:false},
        // { id: 'cko_capture', name: 'CKO Capture Status' ,$isDisabled:false},
        // { id: 'mref', name: 'Merchant Ref. No.' ,$isDisabled:false},
        // { id: 'amount', name: 'Amount' ,$isDisabled:false},
      ],
      advanceFilters: [
        {
          field: { id: "firstname", name: "First Name", $isDisabled: false },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
          history: {
            sender: "",
            receiver: "",
          },
          amount: {
            type: "",
            value: "",
          },
          payout: {
            type: "",
            source: "",
          },
        },
      ],
      transactionStatus: [
        "Initial Request",
        "Callback Pending",
        "Success",
        "Failed",
        "Callback Failed",
        "Callback Success",
      ],
      amountOptions: [
        { id: "greaterthan", name: "Greater Than", $isDisabled: false },
        { id: "lessthan", name: "Less Than", $isDisabled: false },
        { id: "equals", name: "Equals", $isDisabled: false },
      ],
      transactiontypeOptions: [
        "Mobile Money",
        "Bank Deposit",
        "Cash Collection",
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      searchText: "",
    };
  },
  methods: {
    //statusUpdateSubmit
    statusUpdateSubmit(type) {
      console.log("type", type);
      if (type == "transaction") {
        console.log("transactionStatusUpdate", this.transactionStatusUpdate);
      }
      if (type == "transaction_ref") {
        console.log("transaction_ref", this.payoutStatusUpdate);
      }
    },
    //Notification
    transactionNotificationSubmit() {
      console.log("transactionNotificationSubmit", this.notification);
    },
    sendNotification(data) {
      console.log(data);
      this.$bvModal.show("transactionNotification");
    },
    // transaction status_update
    trans_status_update(data) {
      console.log(data);
      this.$bvModal.show("transactionStatusUpdate");
    },
    // transaction payout status_update
    trans_payout_status_update(data) {
      console.log(data);
      this.$bvModal.show("payoutStatusUpdate");
    },
    // for refund
    refund(item) {
      console.log(item);
      ((this.remitterCredit = {
        customer: item.sender,
        comment: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        amount: item?.destamount?.split(" ")[1],
        creditType: "",
        refundType: "Orignal Method",
      }),
        this.$bvModal.show("refund-Remitter-credit"));
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = e.target.value;
        }
      }
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters.length == 0) {
        this.advanceFilters = [
          {
            field: { id: "firstname", name: "First Name", $isDisabled: true },
            search: "",
            country: [],
            history: {
              sender: "",
              receiver: "",
            },
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
            payout: {
              type: "",
              source: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // to append another Filter
    appendFilter() {
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          country: [],
          history: {
            sender: "",
            receiver: "",
          },
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
          payout: {
            type: "",
            source: "",
          },
        });
        if (
          this.filterField.filter((data) => data.$isDisabled == false)[0].id !=
          "amount"
        ) {
          this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0].$isDisabled = true;
        }
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
        if (item.field.id != "amount") {
          item.amount.type = "";
          item.amount.value = "";
        }
      });
      this.amountFieldUpdate();
    },
    // to remove filters
    removeFilter(index) {
      if (this.advanceFilters[index].field.id == "amount") {
        this.amountOptions.filter(
          (data) => data.id == this.advanceFilters[index].amount.type.id,
        )[0].$isDisabled = false;
      }
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("cash-collection-filter", this.displayFilters);
    },
    // remove country filters
    removeCountry(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.countryList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("cash-collection-filter", this.displayFilters);
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("cash-collection-filter", this.displayFilters);
    },
    // remove date filters
    removePayoutSource(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].payout[indexValue] = "";
      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.type == "" && temp.source == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter(
          (data) => data.id == "payout_source",
        )[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("cash-collection-filter", this.displayFilters);
    },
    // remove transaction_history filters
    removetransaction_history(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].history[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.sender == "" && temp.receiver == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter(
          (data) => data.id == "transaction_history",
        )[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      if (this.$route.query.filter) {
        if (this.$route.query.sender && this.$route.query.receiver) {
          if (indexValue == "receiver") {
            this.$router.replace({
              query: { filter: "true", sender: this.$route.query.sender },
            });
          }
          if (indexValue == "sender") {
            this.$router.replace({
              query: { filter: "true", receiver: this.$route.query.receiver },
            });
          }
        } else {
          this.$router.replace({ query: {} });
          this.displayFilters = [];
        }
      } else {
        this.$cookies.set("cash-collection-filter", this.displayFilters);
      }
    },

    // amount filter fields update
    amountFieldUpdate() {
      this.amountOptions.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (item.amount.type) {
          this.amountOptions.filter(
            (data) => data.id == item.amount.type.id,
          )[0].$isDisabled = true;
        }
      });
    },

    // apply filters
    applyTestfilter() {
      if (this.$route.query.filter) {
        this.$router.replace({ query: {} });
      }
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (
          item.field.id == "firstname" ||
          item.field.id == "middlename" ||
          item.field.id == "lastname" ||
          item.field.id == "email" ||
          item.field.id == "transactionstatus" ||
          item.field.id == "transactiontype" ||
          item.field.id == "mref"
        ) {
          data.filter_value = item.search;
        }
        if (item.field.id == "country" || item.field.id == "sourcecountry") {
          let countries = [];
          item.country.map((country) => {
            countries.push(country.countryid);
          });
          data.filter_value = countries;
        }
        if (item.field.id == "remitterstatus") {
          data.filter_value = item.search.value;
        }
        if (item.field.id == "cko_capture") {
          data.filter_value = item.search.name;
        }
        if (item.field.id == "date") {
          data.filter_value = {
            from: item.date.from
              ? moment(item.date.from).format("DD-MM-YYYY")
              : "",
            to: item.date.to ? moment(item.date.to).format("DD-MM-YYYY") : "",
          };
        }
        if (item.field.id == "amount") {
          if (item.amount.type && item.amount.value) {
            data.filter_value =
              item.amount.type.name + ": " + item.amount.value;
          }
        }
        if (item.field.id == "transaction_history") {
          data.filter_value = {
            sender: item.history.sender ? item.history.sender : "",
            receiver: item.history.receiver ? item.history.receiver : "",
          };
        }

        if (item.field.id == "payout_source") {
          data.filter_value = {
            type: item.payout.type.value ? item.payout.type.value : "",
            source: item.payout.source.value ? item.payout.source.value : "",
          };
        }

        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("cash-collection-filter", params);
      this.displayFilters = this.$cookies.get("cash-collection-filter");
      console.log("params", params);
    },
    // clear all filters
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "firstname", name: "First Name", $isDisabled: true },
          search: "",
          country: [],
          history: {
            sender: "",
            receiver: "",
          },
          date: {
            from: "",
            to: "",
          },
          amount: {
            type: "",
            value: "",
          },
          payout: {
            type: "",
            source: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      if (!this.$route.query.filter) {
        this.$cookies.set("cash-collection-filter", this.displayFilters);
      }
    },
    cookieFilters() {
      if (this.$route.query.filter) {
        this.advanceFilters = [
          {
            field: {
              id: "transaction_history",
              name: this.filterField.filter(
                (data) => data.id == "transaction_history",
              )[0].name,
              $isDisabled: true,
            },
            search: "",
            country: [],
            history: {
              sender: this.$route.query.sender
                ? this.$route.query.sender
                : null,
              receiver: this.$route.query.receiver
                ? this.$route.query.receiver
                : null,
            },
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
            payout: {
              type: "",
              source: "",
            },
          },
        ];
        this.displayFilters = [
          {
            filter_field: "transaction_history",
            field_name: "Transaction History",
            filter_value: {
              sender: this.$route.query.sender
                ? this.$route.query.sender
                : null,
              receiver: this.$route.query.receiver
                ? this.$route.query.receiver
                : null,
            },
          },
        ];
      } else {
        this.displayFilters =
          this.$cookies.get("cash-collection-filter") != null
            ? this.$cookies.get("cash-collection-filter")
            : [];
        let filters = [];
        if (this.displayFilters && this.displayFilters.length > 0) {
          this.displayFilters.map((item) => {
            this.filterField.filter(
              (data) => data.id == item.filter_field,
            )[0].$isDisabled = true;
            if (
              item.filter_field == "firstname" ||
              item.filter_field == "middlename" ||
              item.filter_field == "lastname" ||
              item.filter_field == "email" ||
              item.filter_field == "transactionstatus" ||
              item.filter_field == "transactiontype" ||
              item.filter_field == "mref"
            ) {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: item.filter_value,
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "remitterstatus") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: this.remiterOption.filter(
                  (data) => data.name == item.filter_value,
                )[0],
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }

            if (
              item.filter_field == "country" ||
              item.filter_field == "sourcecountry"
            ) {
              let countries = [];
              item.filter_value.map((country) => {
                countries.push(
                  this.countryList.filter(
                    (data) => data.countryid === country,
                  )[0],
                );
              });
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: countries,
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "date") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: item.filter_value.from,
                  to: item.filter_value.to,
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "transaction_history") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: item.filter_value.sender,
                  receiver: item.filter_value.receiver,
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "amount") {
              this.amountOptions.filter(
                (data) => data.name == item.filter_value.split(":")[0],
              )[0].$isDisabled = true;
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: this.amountOptions.filter(
                    (data) => data.name == item.filter_value.split(":")[0],
                  )[0],
                  value: item.filter_value.split(":")[1],
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "payout_source") {
              if (item.filter_value.type == "IBOBank") {
                this.payoutSourceOption = this.banks;
              }
              if (item.filter_value.type == "mobilemoney") {
                this.payoutSourceOption = this.mobileNetworks;
              }
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: this.filterpayouttype.filter(
                    (data) => data.value == item.filter_value.type,
                  )[0],
                  source: this.payoutSourceOption.filter(
                    (data) => data.value == item.filter_value.source,
                  )[0],
                },
              });
            }
          });
          this.advanceFilters = filters;
        }
      }
    },
  },
  watch: {
    countryList() {
      // this.cookieFilters();
    },
  },
  mounted() {
    if (this.countryList.length) {
      this.cookieFilters();
    }
    setTimeout(() => {
      this.cookieFilters();
    }, 1000);
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
